import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { QRCodeSVG } from 'qrcode.react';

import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { isInsideMedianApp } from '../../util/appStore';
import StoreBadges from '../StoreBadges/StoreBadges';

import css from './AppDownloadCard.module.css';

/**
 * "Get the app" card with store links and a QR code (QR is desktop-width
 * only: on a phone you can't scan your own screen, just tap the links).
 * The QR points at /app, which forwards each device to the right store.
 * Not rendered inside the Median app wrapper, where the user already has
 * the app. Starts hidden so it never flashes for app users before the
 * client can check.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {boolean?} props.hideQr  show only the store links
 * @returns {JSX.Element|null}
 */
const AppDownloadCard = props => {
  const { className, hideQr } = props;
  const config = useConfiguration();
  const intl = useIntl();
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(!isInsideMedianApp());
  }, []);

  if (!show) {
    return null;
  }

  const appPageUrl = `${config.marketplaceRootURL}/app`;

  return (
    <div className={classNames(css.root, className)}>
      {hideQr ? null : (
        <div
          className={css.qr}
          role="img"
          aria-label={intl.formatMessage({ id: 'AppDownloadCard.qrLabel' })}
        >
          <QRCodeSVG value={appPageUrl} size={88} marginSize={0} />
        </div>
      )}
      <div className={css.text}>
        <p className={css.title}>
          <FormattedMessage id="AppDownloadCard.title" />
        </p>
        <p className={css.description}>
          <FormattedMessage id="AppDownloadCard.description" />
        </p>
      </div>
      <StoreBadges className={css.links} alwaysShow />
    </div>
  );
};

export default AppDownloadCard;
